import { useSelector } from 'react-redux';
import { UserCircle } from 'tabler-icons-react';

import { getUserName } from '../../../../redux/auth/selectors';

import { UserInfoContainer, UserName } from './style';

export const UserInfo = () => {
  const userName = useSelector(getUserName);

  return (
    <UserInfoContainer>
      <UserName>{userName}</UserName>
      <UserCircle size={24} />
    </UserInfoContainer>
  );
};
